"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var storeName = 'cache';
var CacheHandler = /*#__PURE__*/function () {
  function CacheHandler() {
    (0, _classCallCheck2.default)(this, CacheHandler);
  }
  return (0, _createClass2.default)(CacheHandler, null, [{
    key: "getCurrentCache",
    value: function getCurrentCache() {
      return localStorage[storeName] ? JSON.parse(localStorage[storeName]) : {};
    }
  }, {
    key: "getCurrentCacheByToken",
    value: function getCurrentCacheByToken(tokenName) {
      return this.getCurrentCache()[tokenName];
    }
  }, {
    key: "saveCache",
    value: function saveCache(newCache) {
      localStorage[storeName] = JSON.stringify(_objectSpread(_objectSpread({}, this.getCurrentCache()), newCache));
    }
  }, {
    key: "clearAllCache",
    value: function clearAllCache() {
      var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (all) {
        localStorage.cicCache = '';
        localStorage.cscCache = '';
        localStorage.cache = '';
      } else {
        localStorage[storeName] = '';
      }
    }
  }, {
    key: "clearByToken",
    value: function clearByToken(tokenName) {
      var currCache = this.getCurrentCache();
      currCache[tokenName] = '';
      this.saveCache(currCache);
    }
  }, {
    key: "requestCache",
    value: function requestCache(promiseCallback, tokenName) {
      var _this = this;
      if (!this.getCurrentCacheByToken(tokenName)) {
        var promise = promiseCallback();
        promise.then(function (response) {
          var toCache = {};
          toCache[tokenName] = response;
          _this.saveCache(toCache);
        });
        return promise;
      }
      return new Promise(function (resolve) {
        resolve(_this.getCurrentCacheByToken(tokenName));
      });
    }
  }]);
}();
var _default = exports.default = CacheHandler;